<app-header></app-header>
<app-subheader [title]="title"></app-subheader>
<app-loading></app-loading>
<div class="wrapper mt-5">
        <div class="container" >
            <router-outlet></router-outlet>
        </div>
</div>
<app-footer></app-footer>

<app-snackbar></app-snackbar>